import React, { useState } from 'react'
import {Button, FooterHelp, Link, Page} from '@shopify/polaris'
import { useDispatch, useSelector } from 'react-redux'

import DefaultPinData from '../../libs/default-pin'

import { actionSetSelectedItem, actionSetActivePin } from '../../store/actions'

import ItemListComponent from '../../components/item-list'
import MapperPinsOptionsComponent from '../../components/mapper-pins-options'
import axios from 'axios'

const PinPresetComponent = (props) => {
  const dispatch = useDispatch()
  const activeItem = useSelector(state => state.activeItem)
  const activePinIndex = useSelector(state => state.activePin)
  const [forceListRender, setForceListRender] = useState(null)
  const [isNewPreset, setIsNewPreset] = useState(false)

  const handleEdit = (item) => {
    // dispatch active items
    const data = {
      pins: [
        {
          ...item,
          isPreset: true
        }
      ]
    }
    const action = actionSetSelectedItem(data)
    dispatch(action)
    // dispatch active pins
    const setPinIndexAction = actionSetActivePin(0)
    dispatch(setPinIndexAction)
  }

  const savePreset = () => {
    return axios.post(
      isNewPreset
        ? '/api/v2/admin/presets/new'
        : '/api/v2/admin/presets/save',
      activeItem.pins[0])
  }

  return (
    <Page
      fullWidth
      title='Presets'
      primaryAction={{
        content: 'Add preset',
        onAction: () => {
          setIsNewPreset(true)
          handleEdit(DefaultPinData)
        }
      }}
    >
      <ItemListComponent
        defaultName='Untitled preset'
        forceListRender={forceListRender}
        onClick={(item) => {
          setIsNewPreset(false)
          handleEdit(item)
        }}
        editAction={(item) => ({
          content: 'Edit',
          onAction: () => {
            setIsNewPreset(false)
            handleEdit(item)
          }
        })}
        getCodeAction={() => false}
        resourceName={{
          singular: 'preset',
          plural: 'presets'
        }}
        endpoint={`/api/v2/admin/presets`}
      />
      {
        activePinIndex !== null &&
        <MapperPinsOptionsComponent
          showSaveAction
          onSaveIsPromise
          onSaveAction={savePreset}
          onSavedAction={() => {setForceListRender(Date.now())}}
        />
      }
      <FooterHelp>
        Learn more about<Link url="/docs#/pin-settings?id=without-preset" external> preset settings</Link>
      </FooterHelp>
    </Page>
  )
}

export default PinPresetComponent
